var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNoteIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5013_15696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.99854H12.25C12.1813 6.99854 12.125 7.05479 12.125 7.12354V12.1235H1.875V1.87354H6.875C6.94375 1.87354 7 1.81729 7 1.74854V0.873535C7 0.804785 6.94375 0.748535 6.875 0.748535H1.25C0.973438 0.748535 0.75 0.971973 0.75 1.24854V12.7485C0.75 13.0251 0.973438 13.2485 1.25 13.2485H12.75C13.0266 13.2485 13.25 13.0251 13.25 12.7485V7.12354C13.25 7.05479 13.1938 6.99854 13.125 6.99854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56083 7.35635L4.53115 9.21416C4.52958 9.35322 4.64208 9.46728 4.78115 9.46728H4.7874L6.63115 9.42197C6.6624 9.42041 6.69365 9.40791 6.71552 9.38603L13.214 2.90166C13.2624 2.85322 13.2624 2.77354 13.214 2.7251L11.2718 0.784473C11.2468 0.759473 11.2155 0.748535 11.1827 0.748535C11.1499 0.748535 11.1186 0.761035 11.0936 0.784473L4.59677 7.26885C4.5742 7.29245 4.56137 7.3237 4.56083 7.35635ZM5.55302 7.7251L11.1827 2.10791L11.889 2.8126L6.25615 8.43291L5.54208 8.4501L5.55302 7.7251Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5013_15696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteIconWhite);
export default __webpack_public_path__ + "static/media/addNoteIconWhite.ebc3b0df2548a5ee4111b57f59e0e741.svg";
export { ForwardRef as ReactComponent };